/* Home Page Designer */
/* globals videojs */
'use strict';

var homePageUtils = require('../homePageUtils');
var promotionalTimerUtil = require('../homePage/promotionalTimer');
var slickConfigsHPRedesign = homePageUtils.homePageRedesign;
var injectDynamicUtils = require('../components/injectDynamicUtils');
var processInclude = require('base/util');

var EMP_MODAL_COOKIE_NAME = 'employeeModalShown';
var cookie = require('../util/cookie');

const carouselAllViewType = [
    'carousel-2up',
    'carousel-3up',
    'carousel-4up',
    'carousel-5up',
    'carousel-6up'
];

/**
 * Generates html for promotions section
 * @param {array} carouselDefaultSettings - list of promotions
 * @param {string} slideDView - desktop view type
 * @return {string} - Compiled HTML
 */
const allViewCarouselSettings = (carouselDefaultSettings, slideDView) => {
    let carouselSettings = {};
    let responsiveCarouselSettings = {
        breakpoint: 767,
        settings: 'unslick'
    };

    carouselSettings = Object.assign(
        {},
        carouselDefaultSettings
    );
    carouselSettings.slidesToShow = parseInt(slideDView, 10);
    carouselSettings.slidesToScroll = parseInt(slideDView, 10);
    carouselSettings.responsive = [];
    carouselSettings.responsive.push(responsiveCarouselSettings);

    return carouselSettings;
};

/**
 * function to inject dynamic css for Home Product tile on page scroll
 *
 */
function getHomeProductTileCss() {
    $(window).on('scroll', function () {
        $('body').trigger('product:beforehomeProductTileLoads');
        $(window).off('scroll');
    });
}

/**
 * Remove extra space from product tile
 * @param {Object} $components - jQuery object
 */
function removeExtraSpaceInTile($components) {
    $components.each(function () {
        var flag = true;
        let $component = $(this);
        if ($component.closest('.amplience-carousel').length || ($component.closest('.curated-promo-component').length && homePageUtils.mediaBreakpointUp('sm'))) {
            flag = false;
        }
        if (flag) {
            let hasRatings = false;
            let hasReleaseDate = false;
            let hasPromotions = false;
            let hasInventoryMsg = false;
            let hasProductInfo = false;
            let hasMultiLineInfo = false;
            let hasMultilineInventory = false;
            let hasBadgeContainer = false;
            let hasMultilineBadge = false;

            let $productGrid = $component.find('.product.grid-tile');

            $productGrid.each(function () {
                let $product = $(this);

                if ($product.find('.product-info .pr-1').length) {
                    hasProductInfo = true;

                    if ($product.find('.product-info').height() > 15) {
                        hasMultiLineInfo = true;
                    }
                }

                if ($product.find('.average-rating').length) {
                    hasRatings = true;
                }

                if ($product.find('.releasedate .delivery-message').length) {
                    hasReleaseDate = true;
                }

                if ($product.find('.tile-promotions .promo-callout').length) {
                    hasPromotions = true;
                }

                if ($product.find('.inventoryleft .delivery-home-stock-msg').length) {
                    hasInventoryMsg = true;

                    if ($product.find('.inventoryleft').height() > 15) {
                        hasMultilineInventory = true;
                    }
                }

                if ($product.find('.badge-container-redesign span').length) {
                    hasBadgeContainer = true;

                    if ($product.find('.badge-container-redesign').height() > 24) {
                        hasMultilineBadge = true;
                    }
                }
            });

            if (!hasProductInfo) {
                $component.find('.product-info').remove();
            } else if (hasMultiLineInfo) {
                $component.find('.product-info').addClass('multiLine-info');
            }

            if (!hasRatings) {
                $component.find('.tile-ratings').remove();
            }

            if (!hasReleaseDate) {
                $component.find('.releasedate').remove();
            }

            if (!hasPromotions) {
                $component.find('.tile-promotions').remove();
            }

            if (!hasInventoryMsg) {
                $component.find('.inventoryleft').remove();
            } else if (hasMultilineInventory) {
                $component.find('.inventoryleft').addClass('multiLine-inventory');
            }

            if (!hasBadgeContainer) {
                $component.find('.badge-container-redesign').remove();
            } else if (hasMultilineBadge) {
                $component.find('.badge-container-redesign').addClass('multiline-badge');
                if ($component.closest('.recommendations-redesign-homepage').length) {
                    $component.find('.price .range').addClass('multiline-range');
                }
            } else {
                if ($component.closest('.recommendations-redesign-homepage').length) { // eslint-disable-line no-lonely-if
                    $component.find('.price .range').addClass('has-range');
                }
            }
        }
        return true;
    });
}

/**
 *  Remove details that are not availble
 *  for all the tiles in a given component
 */
function homePageUpdateProductTile() {
    let $components = $('.experience-component .container.carousel-container');
    removeExtraSpaceInTile($components);

    let $recomondationComponent = $('.recommendations-redesign-homepage .recommended-products-caro-redesign');
    if ($recomondationComponent.length) {
        removeExtraSpaceInTile($recomondationComponent);
    }
}

/**
 * Generates homePageDesignerCarousels execuation
 */
function homePageDesignerCarousels() {
    // hero carousel initialize
    $('.hero-caro-redesign').not('.slick-initialized').slick(slickConfigsHPRedesign.heroCarouselRedesign).on('lazyLoaded', function () {
        homePageUtils.imageHeightToSetArrow();
    });
    $('.hero-caro-redesign').css('visibility', 'visible');

    let $heroCarouseE2E = $('.hero-caro-e2e-redesign');
    $heroCarouseE2E.css('visibility', 'hidden');
    $heroCarouseE2E.css('min-height', '300px');
    if ($heroCarouseE2E.length) {
        $('.hero-carousel-container', $heroCarouseE2E).not('.slick-initialized').slick(slickConfigsHPRedesign.heroCarouselE2E).on('lazyLoaded', function () {
            homePageUtils.imageHeightToSetArrow();
        });
        $heroCarouseE2E.css('visibility', 'visible');
        $heroCarouseE2E.css('min-height', 'unset');
    }

    let $bladeCarousel = $('.blade-carousel .blade-carousel-container');
    if ($bladeCarousel.length) {
        $bladeCarousel.not('.slick-initialized').slick(slickConfigsHPRedesign.heroCarouselE2E);
    }

    carouselAllViewType.forEach((viewType) => {
        var desktopViewType = viewType.replace(/[^\d.]/g, '');
        var carouselDefaultSettings = slickConfigsHPRedesign.carouselDefaultSettings;

        $(`.${viewType}`).each((i, elm) => {
            var $carousel = $(elm);
            var $amplienceCarousel = $carousel.closest('.amplience-carousel');

            if ($amplienceCarousel.length) {
                $amplienceCarousel.find('.container.carousel-container').addClass('component-wrapper');
            }

            if (!$carousel.hasClass('has-grid')) {
                var objSlick = allViewCarouselSettings(carouselDefaultSettings, desktopViewType);
                $carousel.not('.slick-initialized').slick(objSlick).on('lazyLoaded', function () {
                    homePageUtils.imageHeightToSetArrow();
                });
            }
       

            $carousel.css('visibility', 'visible');
        });
    });
}

/**
 * New Homepage Carousels v3
 */
$(function () {
    var isVideoCarousel = Boolean(document.querySelector('.gme-v3-carousel-hero--video'));
    var time = isVideoCarousel ? 12000 : 6000;

    $('.js-gme-v3-carousel-hero').on('init', function () {
        var slickActive = document.querySelector('.js-gme-v3-carousel-hero  li.slick-active');
        if (slickActive) {
            slickActive.classList.remove('slick-active');
            setTimeout(() => slickActive.classList.add('slick-active'), 1000);
        }
    });

    $('.js-gme-v3-carousel-hero').not('.gme-v3-carousel-hero--1').slick({
        autoplaySpeed: time,
        dots: true,
        autoplay: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false
    });

    $('.js-gme-v3-banner-carousel').not('.gme-v3-banner-carousel--1').slick({
        autoplaySpeed: 6000,
        arrows: false,
        dots: true,
        autoplay: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false
    });

    $('.js-gme-v3-carousel-topcards').slick({
        autoplaySpeed: 3000,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows: true,
        dots: false,
        autoplay: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        pauseOnDotsHover: true,
        rows: 0,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });
});

/**
 * Check for active icon on deals page
 */
function checkActiveIcon() {
    var currentPageUrl = window.location.href;
    var dealsParam = homePageUtils.getQueryStringParams(currentPageUrl);
    var dealsContentAssetIndex = dealsParam && Object.keys(dealsParam).indexOf('cid');
    var dealsContentAsset = Object.values(dealsParam)[dealsContentAssetIndex];
    var dealsActiveIconIndex = dealsParam && Object.keys(dealsParam).indexOf('selectedtext');
    var dealsActiveIcon = Object.values(dealsParam)[dealsActiveIconIndex];
    if (dealsContentAsset && dealsActiveIcon) {
        var activeItem = Object.values(dealsParam)[dealsActiveIconIndex];
        $('.guided-card-link').each(function () {
            var cardTitle = $(this).find('.gn-title').data('active-status');
            if (activeItem === cardTitle) {
                $(this).find('.gn-title').addClass('active-nav');
                $(this).find('.heading-icon').show();
            }
        });
    } else {
        $('.navigation-option .gn-title').eq(0).addClass('active-nav');
        $('.navigation-option .heading-icon').hide();
        $('.navigation-option .deals-nav-container').addClass('no-heading');
    }
}

/**
 * triggers GiftHub clicked
 * @param {string} infoText - info text
 * @param {string} campaignName - campaign name
 */
function triggerGiftHubClicked(infoText, campaignName) {
    $('body').trigger('gifthub:Clicked', {
        name: infoText,
        heading: campaignName
    });
}

/**
 * trigger protectPurchase init from base.js
 */
function triggerProtectPurchase() {
    $('body').trigger('protectPurchase:init');
}

$('.enhanced-tiles .pd-component .card-carousel').each(function () {
    $(this).on('init reInit afterChange', function (event, slick, currentSlide) {
        var carouselType = $(this).attr('data-carousel-type');
        var carouselValue = carouselType.replace(/[^0-9]/g, '');
        var index = currentSlide ? currentSlide + 1 : 1;
        if (slick.$dots) {
            $(this).parents('.pd-component').find('.pagingInfo').text('Page ' + (parseInt(index / carouselValue, 10) + 1) + ' of ' + (slick.$dots[0].children.length));
        }
    });
});

/**
 * divide icons for stacking
 * @param {string} currStackParent - parent class for multiple stack icons
 * @param {string} iconsLeft - number of icons left to stack
 * @param {string} n2 - number of rows
*/
function stackIconHomePage(currStackParent, iconsLeft, n2) {
    var n;
    if (iconsLeft % 2 === 0) {
        n = iconsLeft / 2;
    } else {
        n = Math.floor(iconsLeft / 2) + 1;
    }
    currStackParent.find('.guided-navs .guided-card-link:eq(' + ((6 * n2) + (n - 1)) + ')').after('<div class="guided-nav-break"></div>');
}

/**
 * @param {Object} video - video object
 * @param {number} headerNav - header offset
 * Homepage takeover video play and pause on scroll.
*/
function videoPlayPause(video, headerNav) {
    var videoContainer = $('.takeover-component .video-card');
    $(document).on('scroll', function () {
        if (videoContainer.length) {
            var elementPosTop = videoContainer.offset().top - headerNav;
            var viewportHeight = $(window).height();
            var scrollPos = $(window).scrollTop();
            var elementFromTop = elementPosTop - scrollPos;
            var expanded = $('.takeover-component .show-more:not(.collapsed)');
            if (elementFromTop > 0 && elementFromTop < elementPosTop + viewportHeight && expanded.length > 0) {
                video.play();
            } else {
                video.pause();
            }
        }
    });
}

/**
 * @param {number} countUpdated - update position for components
 * Dynamic Impression tracking for home page components
*/
function dynamicImpressionTracking(countUpdated) {
    let countCheck = countUpdated;
    let $el = $('.amplience-carousel, .hero-caro-redesign, .pd-component, .hero-caro-e2e-redesign, .guided-navigation');
    $('.amplience-carousel, .hero-caro-redesign, .pd-component, .hero-caro-e2e-redesign, .guided-navigation').each(function () {
        $el = $(this);
        if (!$el.attr('data-viewed')) {
            const config = {
                rootMargin: '0px 0px 0px 0px',
                threshold: 0
            };
            let observer = new IntersectionObserver((entries, self) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        var arryData = [];
                        var promoData = [];
                        var promoCount = 0;
                        var $this = $(entry.target);
                        var $globalHeadingVar = $this.data('creative-name');
                        var $globalComponentType = $this.data('component-name') || '';
                        var eventLabel;
                        var isProductTile = false;
                        $this.find('.amplience-carousel-card, .product-tile-link, .pd-homepage-tile, .amplience-card a, .video-card, .gme-v3-global-widgect').each(function () {
                            let $carouselElement = $(this).closest('.slick-slider');
                            let $clonedSlide = $(this).closest('.slick-cloned');
                            // Removing cloned slides from carousel
                            if (!$carouselElement.length || ($carouselElement.length && !$clonedSlide.length)) {
                                var $localHeadingVar;
                                var headingdata = $globalHeadingVar;
                                if (!headingdata) {
                                    if ($(this).hasClass('pd-homepage-tile')) {
                                        $localHeadingVar = $(this).parents('.pd-component').find('.headingtext');
                                    } else {
                                        $localHeadingVar = $(this).parents('.amplience-carousel').find('.heading');
                                    }
                                    headingdata = $localHeadingVar.length ? $.trim($localHeadingVar.text()) : 'Hero Carousel';
                                }
                                $(this).attr('data-position', countCheck);
                                countCheck++;
                                promoCount++;
                                $(this).attr('data-promo-position', promoCount);
                                eventLabel = headingdata;
                                isProductTile = $(this).hasClass('product-tile-link');
                                if ($(this).data('ci-tracking') || $(this).data('campaign-name')) {
                                    if ($globalComponentType) {
                                        arryData.push({
                                            id: $(this).data('ci-tracking'),
                                            name: $(this).data('campaign-name'),
                                            creative: headingdata,
                                            position: $(this).attr('data-position')
                                        });
                                        promoData.push({
                                            id: isProductTile ? $(this).attr('data-tracking-id') : $(this).data('ci-tracking'),
                                            name: isProductTile ? $(this).attr('data-tracking-name') : $(this).data('campaign-name'),
                                            creative: headingdata,
                                            position: promoCount
                                        });
                                    } else {
                                        arryData.push({
                                            id: $(this).data('ci-tracking'),
                                            name: $(this).data('campaign-name'),
                                            creative: headingdata,
                                            position: $(this).attr('data-position')
                                        });
                                        promoData.push({
                                            id: $(this).data('ci-tracking'),
                                            name: $(this).data('campaign-name'),
                                            creative: headingdata,
                                            position: promoCount
                                        });
                                    }
                                } else if ($globalComponentType) {
                                    arryData.push({
                                        id: $(this).find('a').data('ci-tracking'),
                                        name: $(this).find('a').data('campaign-name'),
                                        creative: headingdata,
                                        position: $(this).attr('data-position')
                                    });
                                    promoData.push({
                                        id: isProductTile ? $(this).attr('data-tracking-id') : $(this).find('a').data('ci-tracking'),
                                        name: isProductTile ? $(this).attr('data-tracking-name') : $(this).find('a').data('campaign-name'),
                                        creative: headingdata,
                                        position: promoCount
                                    });
                                } else {
                                    arryData.push({
                                        id: $(this).find('a').data('ci-tracking'),
                                        name: $(this).find('a').data('campaign-name'),
                                        creative: headingdata,
                                        position: $(this).attr('data-position')
                                    });
                                    promoData.push({
                                        id: $(this).find('a').data('ci-tracking'),
                                        name: $(this).find('a').data('campaign-name'),
                                        creative: headingdata,
                                        position: promoCount
                                    });
                                }
                            }
                        });

                        var obj = {};

                        if ($globalComponentType) {
                            obj = {
                                event: 'Banner Impression',
                                componentType: $globalComponentType,
                                ecommerce: {
                                    promoView: {
                                        promotions: arryData
                                    }
                                }
                            };
                        } else {
                            obj = {
                                event: 'Banner Impression',
                                componentType: $globalComponentType,
                                ecommerce: {
                                    promoView: {
                                        promotions: arryData
                                    }
                                }
                            };
                        }

                        var customDimension = {
                            gtmContainerId: $('#googleTagManagerIdNew').val(),
                            searchInput: obj.searchInput,
                            productSKU: obj.productSKU,
                            searchAutocompleteCategory: obj.searchAutocompleteCategory,
                            searchAutocompleteValue: obj.searchAutocompleteValue,
                            cartValue: obj.cartValue,
                            componentType: $globalComponentType,
                            experienceType: obj.experienceType,
                            filterType: obj.filterType,
                            filterValue: obj.filterValue,
                            persistentSignIn: obj.persistentSignIn,
                            storeId: obj.storeId,
                            memberTier: obj.memberTier,
                            authenticationState: obj.authenticationState,
                            paymentType: obj.paymentType,
                            reviewsRating: obj.reviewsRating,
                            reviewsNumber: obj.reviewsNumber
                        };
                        var customMetric = {
                            orderDiscount: obj.orderDiscount,
                            eventValue: obj.eventValue
                        };
                        var analyticsObj;
                        if (eventLabel && promoData) {
                            analyticsObj = {
                                event: 'analyticsEvent',
                                eventCategory: 'ecommerce',
                                eventAction: 'promotion viewed',
                                eventLabel: eventLabel.toLowerCase(),
                                ecommerce: {
                                    promoView: {
                                        promotions: promoData
                                    }
                                },
                                customDimensions: customDimension,
                                customMetrics: customMetric
                            };
                        }
                        window.dataLayer.push(obj);
                        if (analyticsObj) window.dataLayer.push(analyticsObj);
                        self.unobserve(entry.target);
                        $this.attr('data-viewed', true);
                        $('.page-designer.home-page-redesign').attr('count-update', countCheck);
                    }
                });
            }, config);
            observer.observe($el[0]);
        }
    });
}

/**
 * Adds next/prev paging buttons for scrollable carousels
*/
function configureCarousels() {
    $('.card-carousel').each(function () {
        const $scroll = $(this).find('.scroll-wrapper').get(0);

        if ($scroll) {
            var style = $scroll.currentStyle || window.getComputedStyle($scroll);

            const $tile = $($scroll).find('.v2-enhanced-product-tile').get(0);
            const tileWidth = ($tile ? $tile.offsetWidth : 0) + parseFloat(style.gap);
            const containerWidth = $scroll.offsetWidth;
            const numTile = Math.floor(containerWidth / tileWidth);
            const scrollAmount = tileWidth * numTile;

            const $leftArrow = $($scroll).find('.left-arrow-wrapper').get(0);
            const $rightArrow = $($scroll).find('.right-arrow-wrapper').get(0);

            const hideShowArrows = (scrollDiv) => {
                if ($leftArrow) {
                    if (scrollDiv.scrollLeft === 0) {
                        $($leftArrow).addClass('d-none');
                    } else {
                        $($leftArrow).removeClass('d-none');
                    }
                }
                const fullwidth = scrollDiv.scrollWidth - scrollDiv.offsetWidth;
                if ($rightArrow) {
                    if (scrollDiv.scrollLeft === fullwidth) {
                        $($rightArrow).addClass('d-none');
                    } else {
                        $($rightArrow).removeClass('d-none');
                    }
                }
            };

            hideShowArrows($scroll);

            $($scroll).on('scroll', e => {
                hideShowArrows(e.target);
            });

            $($($leftArrow).find('.left-arrow').get(0)).on('click', e => {
                e.preventDefault();
                e.stopPropagation();
                $scroll.scrollTo({
                    left: $scroll.scrollLeft - scrollAmount,
                    behavior: 'smooth'
                });
            });

            $($($rightArrow).find('.right-arrow').get(0)).on('click', e => {
                e.preventDefault();
                e.stopPropagation();
                $scroll.scrollTo({
                    left: $scroll.scrollLeft + scrollAmount,
                    behavior: 'smooth'
                });
            });
        }
    });
}

$(document).ready(function () {
    processInclude(require('../powerUpRewards/onlineEnrollment'));

    if ($('.product-tile').visible(true)) {
        $('body').trigger('product:beforehomeProductTileLoads');
    } else {
        getHomeProductTileCss();
    }
    if ($('.navigation-option').length) {
        checkActiveIcon();
    }
    $('.pd-component').each(function () {
        $(this).find('.pd-homepage-tile').each(function () {
            var $headingVal = $(this).parents('.pd-component').find('.headingtext');
            var $listItemType = $.trim($headingVal.text());
            $(this).attr('data-list-item-type', $listItemType);
        });
    });

    var $employeeModalSelector = $('.employee-validation-modal');
    var employeeModalCookie = cookie.get(EMP_MODAL_COOKIE_NAME);
    if ($employeeModalSelector.length && !employeeModalCookie) {
        var url = $employeeModalSelector.data('url');
        $.get(url).done(function (data) {
            $employeeModalSelector.append(data);
            if ($('#employeeValidationModal').length > 0) {
                cookie.set(EMP_MODAL_COOKIE_NAME, true);
                $('#employeeValidationModal').modal('show');
            }
        });
    }
    configureCarousels();
});

const pageDesignerCarousels = () => {
    if ($('.page-edit-mode').length > 0) {
        window.onload = () => {
            setTimeout(function () {
                homePageDesignerCarousels();
            }, 500);
        };
    } else {
        homePageDesignerCarousels();
    }
};

$('.curated-pd-container.hovering-tile .product-tile').hover(
    function () {
        if (homePageUtils.mediaBreakpointUp('sm')) {
            var hoverStateContainer = ('.product-tile-header.hover-state');
            var hoverStateCheck = $(this).find(hoverStateContainer).length;
            if (hoverStateCheck === 1) {
                $(this).find(hoverStateContainer).show();
            } else {
                var $tileWrapper = $(this).find('.tile-body');
                var $productInfo = $tileWrapper.find('.product-tile-header').html();
                $tileWrapper.append($('<div class="product-tile-header hover-state">' + $productInfo + '</div>'));
                var tilePromoCopy = $tileWrapper.find(hoverStateContainer + ' .tile-promotions');
                if (tilePromoCopy.length) {
                    var $promopositioning = $tileWrapper.find(hoverStateContainer + ' .price-ctc-container .pricing-homepagetile');
                    var $promoCopy = $tileWrapper.find(tilePromoCopy).html();
                    $tileWrapper.find(hoverStateContainer + ' > .tile-promotions').remove();
                    $promopositioning.append($('<div class="tile-promotions">' + $promoCopy + '</div>'));
                }
            }
            var curatedProductTile = $(this).find(hoverStateContainer);
            var curatedTileATC = curatedProductTile.find('.add-to-cart-plp').get(0);
            curatedProductTile.on('click', function (e) {
                if (e.target !== curatedTileATC) {
                    var productUrl = $(this).find('.pdp-link .link').attr('href');
                    window.location.href = productUrl;
                }
            });
        }
    },
    function () {
        if (homePageUtils.mediaBreakpointUp('sm')) {
            $(this).find('.product-tile-header.hover-state').hide();
        }
    }
);

module.exports = {
    protectPurchase: triggerProtectPurchase,
    promotionalTimerUtil: promotionalTimerUtil,

    // to show "+ x other offer(s)" for product promotions
    morePromotions: function () {
        setTimeout(function () {
            var $promoProducts = $('.more-promotions-product');
            if ($promoProducts.length) {
                $promoProducts.each(function (index) {
                    var $currentProductPromo = $($promoProducts[index]);
                    var $noOfPromotions = $currentProductPromo.attr('data-promo-count');
                    var $checkPromoStatus;
                    var $callout = $currentProductPromo.siblings($('.callout'));
                    var $calloutMsgWidth = $callout
                        .clone()
                        .addClass($currentProductPromo + ' promo-dynamic')
                        .css({ display: 'inline', visibility: 'hidden' })
                        .appendTo('body');
                    if (homePageUtils.mediaBreakpointDown('sm')) {
                        $checkPromoStatus = ($calloutMsgWidth.height() > 32);
                    } else {
                        if ($callout.closest('.grid-2-3-column-blade-container').length) { // eslint-disable-line no-lonely-if
                            let tileWidth = $callout.closest('.product-tile').width() - 32;
                            $checkPromoStatus = ($calloutMsgWidth.width() / 4) > tileWidth;
                        } else {
                            $checkPromoStatus = ($calloutMsgWidth.width() / 2) > $callout.width();
                        }
                    }
                    if ($noOfPromotions > 1 && $checkPromoStatus === true) {
                        $callout.removeClass('promo-text-extend');
                        $currentProductPromo
                            .addClass('more-promo-stick')
                            .prepend('<span class="set-ellipsis">... </span>');
                    }
                    if ($noOfPromotions > 1 && $checkPromoStatus === false) {
                        $callout.removeClass('promo-text-extend');
                        $currentProductPromo.show();
                    }
                    $calloutMsgWidth.remove();
                });
            }
        }, 2000);
    },
    promotionClicked: function () {
        $(document).on('click', '.product-tile-link, .amplience-carousel-card, .pd-homepage-tile, .amplience-card:not(.video-card)', function () {
            var headingdata;
            var $headingVal;
            var $globalComponentType;
            var $ampCarousel = $(this).parents('.amplience-carousel');
            var $productCard = $(this).parents('.pd-component');
            if ($(this).hasClass('amplience-carousel-card') || $(this).hasClass('amplience-card')) {
                headingdata = $ampCarousel.data('creative-name');
                $globalComponentType = $ampCarousel.data('component-name') || '';
            } else if ($(this).hasClass('product-tile-link') || $(this).hasClass('pd-homepage-tile')) { // Condition for enhanced page designer component
                headingdata = $productCard.data('creative-name');
                $globalComponentType = $productCard.data('component-name') || '';
            }

            // NEW - Missing cases for data-creative name
            if (!headingdata) {
                if ($(this).parents('.guided-navigation').length) {
                    headingdata = $(this).parents('.guided-navigation').data('creative-name');
                } else if ($(this).parents('.hero-caro-e2e-redesign').length) {
                    headingdata = $(this).parents('.hero-caro-e2e-redesign').data('creative-name');
                } else if ($(this).parents('.pd-component').length) {
                    headingdata = $(this).parents('.pd-component').data('creative-name'); // Condition for banner from amplience in curated pd component
                }
            }
            // Older implementation - to be deleted
            if (!headingdata) {
                if ($(this).hasClass('amplience-carousel-card') || $(this).hasClass('amplience-card')) {
                    $headingVal = $(this).parents('.amplience-carousel').find('.heading');
                } else if ($(this).hasClass('pd-homepage-tile')) {
                    $headingVal = $(this).parents('.pd-component').find('.headingtext');
                }
                headingdata = ($headingVal.length ? $.trim($headingVal.text()) : 'Hero Carousel');
            }
            var campaignID = $(this).data('ci-tracking') || $(this).find('a').data('ci-tracking');
            var campaignName = $(this).data('campaign-name') || $(this).find('a').data('campaign-name');
            var position = $(this).data('position');
            if (!position) position = $(this).children('a').data('position');
            var promoPosition = $(this).data('promo-position');
            if (!promoPosition) promoPosition = $(this).children('a').data('promo-position');
            if ($globalComponentType) {
                var componentType = $globalComponentType;
                var productSku = $(this).attr('data-tracking-id');
                var productName = $(this).attr('data-tracking-name');
                $('body').trigger('promotion:bannerPromotionClicked', { componentType: componentType, campaignID: campaignID, campaignName: campaignName, heading: headingdata, position: position, id: productSku, productName: productName, promoPosition: promoPosition });
            } else {
                $('body').trigger('promotion:promotionalClicked', { campaignID: campaignID, campaignName: campaignName, heading: headingdata, position: position, promoPosition: promoPosition });
            }
        });
    },
    giftHubClicked: function () {
        if (window.pageContext.ns === 'search') {
            $('.amplience-carousel .justify-content-center div').on('click', function () {
                let infoText = $(this).parent('.justify-content-center').siblings('.product-content-info').text();
                let campaignName = $(this).find('a').data('campaignName');

                triggerGiftHubClicked(infoText.trim(), campaignName);
            });

            $('.amplience-carousel .mt-3 div').on('click', function () {
                let infoText = $(this).parent('.mt-3').siblings('.product-content-info').text();
                let campaignName = $(this).find('p').text();

                triggerGiftHubClicked(infoText.trim(), campaignName.trim());
            });

            $('.amplience-carousel .carousel-3up-container .carousel-3up .product-detail').on('click', function () {
                let infoText = $(this).parents('.carousel-3up').siblings('.product-content-info').text();
                let campaignName = $(this).find('.pdp-link').text();

                triggerGiftHubClicked(infoText.trim(), campaignName.trim());
            });

            $('.sidebyside-image-container .amplience-carousel-card').on('click', function () {
                let campaignName = $(this).data('campaignName');
                let infoText = campaignName;

                triggerGiftHubClicked(infoText.trim(), campaignName.trim());
            });

            $('.experience-component .justify-content-center .hnav').on('click', function () {
                let campaignName = $(this).text();
                let infoText = campaignName;

                triggerGiftHubClicked(infoText.trim(), campaignName.trim());
            });

            $('.analytics-trigger').on('click', function () {
                let campaignName = $(this).data('analyticsText');
                let infoText = campaignName;

                triggerGiftHubClicked(infoText.trim(), campaignName.trim());
            });
        }
    },
    promotionViewed: function () {
        var countCheck = 1;

        if ($('.site-wide-banner').length) {
            // updating the position count if free shipping banner is visible
            countCheck = 2;
        }

        if (window.dataLayer) {
            window.dataLayer.forEach(function (obj, index) {
                if (obj.event === 'Page Loaded') {
                    var dataLayerObj = window.dataLayer[index];
                    if ($('span').hasClass('landingpage')) {
                        var $landingpage = $('.landingpage');
                        var pageDesign = $landingpage.attr('data-pageDesign');
                        var pageType = $landingpage.attr('data-pagetype');
                        dataLayerObj.page.pageTemplateDesign = pageDesign;
                        dataLayerObj.page.pageType = pageType;
                    }
                }
            });
        }

        countCheck = $('.page-designer.home-page-redesign').attr('count-update') ? parseInt($('.page-designer.home-page-redesign').attr('count-update'), 10) : countCheck;

        setTimeout(() => {
            dynamicImpressionTracking(countCheck);
        }, 1000);
    },
    listingViewed: function () {
        var productTileData = [];
        var countCheck = 1;
        $('.pd-component').each(function () {
            $(this).find('.pd-homepage-tile').each(function () {
                var $headingVal = $(this).parents('.pd-component').find('.headingtext');
                $(this).attr('data-position', countCheck);
                var productData = $(this).data('product-info');
                countCheck++;
                productTileData.push({
                    productInfo: {
                        variant: productData.productInfo.variant,
                        sku: productData.productInfo.sku,
                        productID: $(this).data('pid'),
                        name: productData.productInfo.name,
                        category: productData.productInfo.category,
                        brand: productData.productInfo.brand,
                        subGenre: productData.productInfo.subGenre,
                        platform: productData.productInfo.platform,
                        genre: productData.productInfo.genre,
                        condition: productData.productInfo.condition,
                        availability: productData.productInfo.availability
                    },
                    price: {
                        sellingPrice: productData.price.sellingPrice,
                        basePrice: productData.price.basePrice
                    },
                    itemPosition: $(this).attr('data-position'),
                    itemListType: $headingVal.length ? $.trim($headingVal.text()) : 'Hero Carousel'
                });
            });
        });
        if (window.dataLayer) {
            window.dataLayer.forEach(function (obj, index) {
                if (obj.event === 'Listing Viewed') {
                    var dataLayerObj = window.dataLayer[index];
                    var listing = {
                        listingResults: {
                            item: productTileData
                        }
                    };
                    dataLayerObj.listing = listing;
                }
            });
        }
    },
    // To Lazy Load Page designer regions on Home page.
    loadRegionsViaAjax: function () {
        let $self = $(this);
        let $el = $('#addRegionsViaAjax');
        if ($el.length) {
            let url = $el.data('href');
            const config = {
                rootMargin: '0px 0px 200px 0px',
                threshold: 0
            };
            let observer = new IntersectionObserver((entries, self) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        $(entry.target).spinner().start();
                        $.ajax({
                            url: url,
                            method: 'get'
                        }).done(function (data) {
                            $(entry.target).spinner().stop();
                            $(data).insertAfter($el);
                            homePageDesignerCarousels();

                            // Removing extra space from tile after Regions Lazy Load
                            homePageUpdateProductTile();
                            promotionalTimerUtil();

                            // adjusting arrow position for Amplience component
                            homePageUtils.imageHeightToSetArrow();

                            if ($('.order-history-details').length) {
                                // let $orderDetailIp = $('#hp-order-detail-js-url');
                                // let pathOd = $orderDetailIp.data('jspath');
                                // $.getScript(pathOd);

                                $('body').trigger('orderDetailDetected');
                            }
                            $self[0].promotionViewed();
                        });
                        self.unobserve(entry.target);
                    }
                });
            }, config);
            observer.observe($el[0]);
        }
    },
    curatedTileDetected: function () {
        if ($('.curated-component').length) {
            if (homePageUtils.mediaBreakpointDown('sm')) {
                var mobileTile = $('.curated-mobile-tile').wrap('<p/>').parent().html();
                $('.curated-mobile-tile').unwrap();
                $('.curated-pd-container .carousel-3up').append('<div class="product grid-tile"><div class="product-tile product-detail pd-homepage-tile">' + mobileTile + '</div></div>');
            }
        }
    },
    orderDetailDetected: function () {
        $('body').on('orderDetailDetected', function () {
            injectDynamicUtils.injectDynamicJs('#hp-order-detail-js-url');
        });
    },
    guidedNav: function () {
        if ($('.guided-navigation-enhanced.stacked').length) {
            $('.guided-navigation-enhanced.stacked').each(function () {
                var iconsCount = $(this).find('.amplience-carousel-card.guided-card-link').length;
                var n1;
                var n2;
                var n3;
                if (iconsCount > 6) {
                    n1 = Math.floor(iconsCount / 6);
                    n2 = n1 - 1;
                    for (var i = 1; i <= n2; i++) {
                        $(this).find('.guided-navs .guided-card-link:eq(' + ((6 * i) - 1) + ')').after('<div class="guided-nav-break"></div>');
                    }
                    n3 = iconsCount - (6 * n2);
                    if (n3 > 6) {
                        stackIconHomePage($(this), n3, n2);
                    }
                }
            });
        }
        if ($('.guided-navigation-enhanced.carousel').length) {
            $('.guided-navigation-enhanced.carousel').each(function () {
                var iconsCarCount = $(this).find('.amplience-carousel-card.guided-card-link').length;
                if (iconsCarCount <= 6) {
                    $(this).find('.guided-navs').removeClass('carousel-6up');
                }
            });
        }
    },
    homepageTakeover: function () {
        var mainHeader = $('.main-header-container.sticky-header-redesign').height();
        var topBar = $('.header-banner.header-banner-redesign').height();
        var headerNav = mainHeader + topBar;
        var hasVideo;
        $(document).on('click', '.takeover-component .show-more:not(.collapsed)', function () {
            var topOfElement = $('.takeover-component').offset().top - headerNav;
            window.scroll({ top: topOfElement });
            hasVideo = $('#myPlayerID video');
            var myPlayer = videojs.getPlayer('myPlayerID');
            if (hasVideo.length) {
                myPlayer.src(myPlayer.src());
                myPlayer.pause();
            }
        });
        $(document).on('click', '.takeover-component .show-more.collapsed', function () {
            hasVideo = $('#myPlayerID video');
            if (hasVideo.length) {
                var video = hasVideo[0];
                var myPlayer = videojs.getPlayer('myPlayerID');
                setTimeout(function () {
                    if (video.paused) {
                        myPlayer.muted(true);
                        myPlayer.play();
                    } else {
                        myPlayer.pause();
                    }
                }, 1000);

                videoPlayPause(myPlayer, headerNav);
            }
        });
    },
    homepageTakeoverCollapse: function () {
        var dataLayer = window.dataLayer;
        $(document).on('click', '.takeover-component .show-more', function () {
            var creativeName = $(this).closest('.amplience-carousel').find('.amplience-card a').first()
            .data('ci-tracking');
            if ($(this).hasClass('collapsed')) {
                // Banner Collapse
                dataLayer.push({
                    event: 'Expand/Collapse',
                    eventDetails: {
                        eventAction: 'collapse',
                        eventLabel: creativeName
                    }
                });
            } else {
                // Banner Expand
                dataLayer.push({
                    event: 'Expand/Collapse',
                    eventDetails: {
                        eventAction: 'expand',
                        eventLabel: creativeName
                    }
                });
            }
        });
    },
    openTradeWizardModal: function () {
        $(document).on('click', '.trade-in-redesign .amplience-card a', function () {
            $('.trade-in-redesign .amplience-card').removeClass('active-state');
            $(this).closest('.amplience-card').addClass('active-state');
        });
    },
    pageDesignerCarousels,
    homePageUpdateProductTile
};
